// import React from "react";

// function TextHeader({leadershipClass, headerImg, headerText, headerDesc ,headerDescClass,alt,post_date}) {

//   const options = {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric',
//   };

//  console.log("leadershipClass :",leadershipClass)



//   return (
//   <div
//   className={`text-card ${leadershipClass ? "text-card--leadership" : ""}`}
//   style={{ width: "100%", flex: "1", gap: leadershipClass ? "0" : "1rem" }}
// >

//     <div
//     //  style={{width:"120px"}}
//      >
//     <img
//         src={headerImg}
//         alt={alt}
//         loading="lazy"
//        className={leadershipClass ? `leadershipClass` : "headerImg"}
//         width="120"
//         height="80"
//       />
//     </div>

//       <div className="main-text" style={{ width: "100%" }}>
//         <h5 className="headerText fw-bold line-clamp">{headerText}</h5>
//         <p className={`header-desc ${headerDescClass}`}  style={{fontSize:"12px",paddingBottom:"-10px",marginTop:"-20px"}}>
//         By <span className="fw-bold">{headerDesc}</span> | {new Date(post_date).toLocaleDateString(undefined, options) }  
//         </p>
//       </div>
//     </div>
//   );
// }

// export default React.memo(TextHeader);


import React from "react";

function TextHeader({ leadershipClass, headerImg, headerText, headerDesc, headerDescClass, alt, post_date }) {
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  return (
    <div
      className="text-card"
      style={{
        width: "100%",
        flex: "1",
        // gap is 0 when leadershipClass is present (mobile), 1rem otherwise
        gap: leadershipClass ? "0" : "1rem",
      }}
    >
      <div>
        <img
          src={headerImg}
          alt={alt}
          loading="lazy"
          className={leadershipClass ? `leadershipClass` : "headerImg"}
          width="120"
          height="80"
        />
      </div>

      <div className="main-text" style={{ width: "100%" }}>
        <h5 className="headerText fw-bold line-clamp">{headerText}</h5>
        <p className={`header-desc ${headerDescClass}`} style={{ fontSize: "12px", paddingBottom: "-10px", marginTop: "-20px" }}>
          By <span className="fw-bold">{headerDesc}</span> | {new Date(post_date).toLocaleDateString(undefined, options)}
        </p>
      </div>

      {/* Inline media-query via style tag injected only for leadership section on desktop */}
      {leadershipClass && (
        <style jsx>{`
          @media (min-width: 1025px) {
            .text-card {
              gap: 1rem !important;
            }
          }
        `}</style>
      )}
    </div>
  );
}

export default React.memo(TextHeader);
